import { Collapse, Modal, Tab } from 'bootstrap';
window.bootstrap = { Collapse, Modal, Tab };

import { whenDocumentReady } from '../../../paws/assets/frontend/js/helper/documentready';
import { whenResize } from '../../../paws/assets/frontend/js/helper/resize';
import { wsForm } from '../../../paws/assets/frontend/js/helper/wsform';

whenDocumentReady(initModule);
whenResize(resizeModule);
function initModule() {
    // header height
    SetHeaderHeight();
    wsForm();
    DetectScroll();
    document.body.classList.add('paws-loaded');
}

function resizeModule() {
    SetHeaderHeight();
}

function DetectScroll() {
    document.addEventListener('scroll', function(e) {
        if (window.scrollY > 0) {
            document.body.classList.add('paws-scrolled');
        }
        else {
            document.body.classList.remove('paws-scrolled');
        }
    })
}

function SetHeaderHeight() {
    let headerHeight = 0;
    const header = document.querySelector('header');
    if (header) {
        headerHeight = header.offsetHeight;
    }

    const wpadminbar = document.querySelector('#wpadminbar');
    if (wpadminbar) {
        document.documentElement.style.setProperty('--paws-adminbar-height', wpadminbar.offsetHeight + 'px');
    }
    else {
        document.documentElement.style.setProperty('--paws-adminbar-height', 0);
    }

    if (headerHeight < 1) {
        setTimeout(function() {SetHeaderHeight()}, 250);
    }

    window.headerHeight = headerHeight;
    document.documentElement.style.setProperty('--noss-header-height', headerHeight + 'px');
}